import styled from 'styled-components'

export const LoaderContainer = styled.div`
  width: 100%;
  height: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
`
